var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.25C15.3325 5.25 19.25 9.16751 19.25 14V20.8789C19.25 21.9121 18.4121 22.75 17.3789 22.75H3.62109C2.58794 22.75 1.75 21.9121 1.75 20.8789V14C1.75 9.16751 5.66751 5.25 10.5 5.25Z",
    stroke: "#0F4B47",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5C8 16.9444 8.5 18.5 10.5 18.5C12.5 18.5 13 16.9444 13 16.5",
    stroke: "#0F4B47",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5C6 13.5 6.3 11.5 7.5 11.5C8.7 11.5 9 13.5 9 13.5",
    stroke: "#0F4B47",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5C12 13.5 12.3 11.5 13.5 11.5C14.7 11.5 15 13.5 15 13.5",
    stroke: "#0F4B47",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.5L22 3.5",
    stroke: "#0F4B47",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.5L20 1.5",
    stroke: "#0F4B47",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessage);
export default __webpack_public_path__ + "static/media/chat-message.63654bc231c47b1f8041d8788a6d4ad8.svg";
export { ForwardRef as ReactComponent };